mutation LoginStep1 (
    $email: String!
) {
    loginStep1(email: $email) {
        status
        message
    } 
}
